import { useRouter } from 'next/router';

// import { useConfirmTxn } from '~/hooks/revival/useConfirmRevival';
import { decrementLevel } from '~/utils/utils';
const baseCDN = process.env.NEXT_PUBLIC_BASE_CDN;

function SuccessWarrior({ warrior }: { warrior: any }) {
  const router = useRouter();
  const id = warrior.id;
  const level: any = warrior.attributes.find(
    (attribute) => attribute.trait_type === 'Level'
  )?.value;
  const basePath = `${baseCDN}/${warrior.id}`;
  const activeImage = `${basePath}/${decrementLevel(level)}.clear.gif`;
  return (
    <>
      <h2 className="is-visually-hidden">It&rsquo;s Alive!</h2>
      <img
        className="its-alive-text"
        src="/img/its-alive.svg"
        alt="It's Alive!"
        aria-hidden="true"
      />
      <div className="its-alive">
        <div className="its-text">
          <img src="/img/its.svg" alt="It's" aria-hidden="true" />
        </div>
        <div className="alive-text">
          <img src="/img/alive.svg" alt="Alive" aria-hidden="true" />
        </div>
        <div className="empty-potion">
          <img src="/img/potion-empty400.png" alt="Empty Potion" />
        </div>
        <div className="warrior-alive">
          <img src={activeImage} alt={`Peacefall ${id}`} />
        </div>
      </div>
      <button className="button" type="button" onClick={() => router.reload()}>
        Revive Another Warrior
      </button>
      <small className="revival-note">
        * May take a little while to show on OpenSea
      </small>
    </>
  );
}

export default SuccessWarrior;
